import api from '../api'

export const changePasswordApi = (t) => (password) =>
  api.auth(t).put('/api/commerce/change-password', {
    password,
  }).toPromise()
